export default "__VITE_ASSET__D$vHZhWo__"